import { Trans } from '@lingui/macro'
import { RowBetween } from 'components/Row'
import { useState } from 'react'
import { ChevronDown } from 'react-feather'
import styled from 'styled-components/macro'
import { ThemedText } from 'theme'

const Header = styled(RowBetween)`
  cursor: pointer;
  padding: 4px 0;
  align-items: center;
`

const Title = styled(ThemedText.BodySecondary)`
  color: ${({ theme }) => theme.textPrimary};
  font-size: 14px;
`

const ExpandIcon = styled(ChevronDown)<{ $isExpanded: boolean }>`
  width: 18px;
  height: 18px;
  transition: transform 0.2s ease;
  transform: ${({ $isExpanded }) => ($isExpanded ? 'rotate(180deg)' : 'rotate(0deg)')};
  color: ${({ theme }) => theme.textSecondary};
`

const SourcesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
  margin-top: 8px;
`

const SourceItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
`

const SourceName = styled(ThemedText.Caption)`
  color: ${({ theme }) => theme.textPrimary};
  font-size: 12px;
  flex: 1;
  margin-right: 8px;
`

const Switch = styled.div<{ isActive: boolean }>`
  width: 28px;
  height: 16px;
  border-radius: 8px;
  background-color: ${({ theme, isActive }) => (isActive ? theme.accentAction : theme.backgroundInteractive)};
  border: 1px solid ${({ theme, isActive }) => (isActive ? theme.accentAction : theme.backgroundOutline)};
  position: relative;
  cursor: not-allowed;
  transition: all 0.2s ease;
  opacity: 0.6;
`

const SwitchThumb = styled.div<{ isActive: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.white};
  position: absolute;
  top: 1px;
  left: ${({ isActive }) => (isActive ? '13px' : '1px')};
  transition: left 0.2s ease;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  opacity: 0.8;
`

const LIQUIDITY_SOURCES = [
  { name: 'PulseX v1', enabled: true },
  { name: 'PulseX v2', enabled: true },
  { name: 'PulseX Stable', enabled: true },
  { name: 'Phux', enabled: true },
  { name: 'Tide', enabled: true },
  { name: '9inch v2', enabled: true },
  { name: '9inch v3', enabled: true },
  { name: '9mm v2', enabled: true },
  { name: '9mm v3', enabled: true },
  { name: 'pDex v3', enabled: true },
  { name: 'pDex Stable', enabled: true },
  { name: 'DexTop', enabled: true },
  { name: 'Uniswap v2', enabled: true },
  { name: 'Uniswap v3', enabled: true },
]

export default function LiquiditySourcesSettings() {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div>
      <Header onClick={() => setIsExpanded(!isExpanded)}>
        <Title>
          <Trans>Liquidity Sources</Trans>
        </Title>
        <ExpandIcon $isExpanded={isExpanded} />
      </Header>

      {isExpanded && (
        <SourcesGrid>
          {LIQUIDITY_SOURCES.map((source) => (
            <SourceItem key={source.name}>
              <SourceName>{source.name}</SourceName>
              <Switch isActive={source.enabled}>
                <SwitchThumb isActive={source.enabled} />
              </Switch>
            </SourceItem>
          ))}
        </SourcesGrid>
      )}
    </div>
  )
}
